import { FunctionComponent } from 'react';
import { Button } from '@/components/common/Button';
import { ConfigurationsPreview } from '@/components/common/ConfigurationsPreview';
import {
  Modal,
  ModalButtons,
  ModalContent,
  ModalHeader,
  ModalTitle,
} from '@/components/common/modal/modal';

interface Props {
  cids: number[];
  title: string;
  hint: string;
  acceptText: string;
  cancelText: string;
  onAccept: () => void;
  onCancel: () => void;
}

export const SwitchDialog: FunctionComponent<Props> = ({
  cids,
  title,
  hint,
  acceptText,
  cancelText,
  onAccept,
  onCancel,
}) => {
  return (
    <Modal title={title} className="switch-dialog" onClose={onCancel}>
      <ModalHeader>
        <ModalTitle>{title}</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <p>{hint}</p>
        <ConfigurationsPreview cids={cids} />
      </ModalContent>
      <ModalButtons>
        <Button onClick={onCancel} light>
          {cancelText}
        </Button>
        <Button onClick={onAccept}>{acceptText}</Button>
      </ModalButtons>
    </Modal>
  );
};
